import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { McvLogo } from '~/components/logos';
import { paths } from '~/routing';
import { buildBrandSwitchUrl } from '~/routing/brandSwitch';

/**
 * Provider-only exit from the HLX workspace.
 *
 * This is a native anchor because the destination is on the MCV origin. The
 * caller renders it only in a provider HLX view, and the dashboard destination
 * keeps the return trip inside that provider's Vault workspace.
 */
export const HlxMcvSwitchLink = () => {
  const accessibleLabel = 'Go to MedCredVault dashboard';
  const href = buildBrandSwitchUrl('mcv', paths.vault.dashboard);

  return (
    <a
      href={href}
      aria-label={accessibleLabel}
      data-cy="hlx-mcv-switch-link"
      className="flex items-center gap-2.5 px-3 py-2 mx-2 rounded-md text-grey-200 hover:bg-white/50 transition-colors duration-150"
    >
      <span aria-hidden="true" className="flex shrink-0 items-center justify-center">
        <McvLogo label="icon" height={20} />
      </span>
      <span className="text-sm font-medium">MedCredVault</span>
      <ArrowTopRightOnSquareIcon
        aria-hidden="true"
        className="ml-auto size-4 shrink-0 text-grey-400"
      />
    </a>
  );
};
